<template>
	<div class="on_sale_table">
		<div class="table" >
			<el-table ref="multipleTable" :height="590" :border="false" :data="tableData" tooltip-effect="dark"
				style="font-size: 0.75rem;" @selection-change="handleSelectionChange">
				<el-table-column align="center" type="selection" label="">
				</el-table-column>
				<el-table-column align="center" label="排序(输入数字进行排序)">
					<template slot-scope="scope">
						<el-input size="mini" style="width: 130px;" type="number" v-model="scope.row.sort">
							<template slot="append">
								<el-button @click="sortBumber(scope.row)" style="cursor: pointer;" size="mini">
									完成
								</el-button>
							</template>
						</el-input>
					</template>
				</el-table-column>
				<el-table-column align="center" label="产品编号" width="120">
					<template slot-scope="scope">{{ scope.row.id }}</template>
				</el-table-column>
				<el-table-column align="center" prop="title"  label="产品分类名称" >
				</el-table-column>
				<el-table-column align="center" prop="goods_count"  label="产品数量" >
				</el-table-column>
				<el-table-column align="center" prop="address" label="操作"  show-overflow-tooltip>
					<template slot-scope="scope">
						<el-button size="mini"
							style="background: #1E69FF;color: #FFFFFF; width: 5rem;height: 1.4rem;line-height: 1.4rem;padding: 0;"
							round @click="openDetail(scope.$index, scope.row)">查看</el-button>
						<!-- <el-button size="mini"
							style="background: #FF9D1F;color: #FFFFFF; width: 5rem;height: 1.4rem;line-height: 1.4rem;padding: 0;"
							round @click="handleEdit(scope.$index, scope.row)">编辑</el-button> -->
						<i class="el-icon-delete" style="margin-left: 10px;cursor: pointer;font-size: 1.3rem;"
							@click="handleDelete(scope.$index, scope.row)"></i>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<footer class="d-flex j-sb a-center">
			<div class="d-flex a-center">
				<!-- <div @click="batchOffshelves" style="cursor: pointer; width: 5.63rem; height: 1.25rem;line-height: 1.25rem;margin-right: 2rem; text-align: center; font-size: 0.75rem;font-weight: bold;border: 2px solid #000000;border-radius: 0.625rem;">
					批量下架</div> -->
				<div @click="batchDelshelves" style="cursor: pointer; width: 5.63rem; height: 1.25rem;line-height: 1.25rem;text-align: center; font-size: 0.75rem;font-weight: bold;border: 2px solid #000000;border-radius: 0.625rem;">
					批量删除</div>
			</div>
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page.sync="currentPage" :page-size="pageSize" layout="prev, pager, next, total" :total="total_records">
			</el-pagination>
		</footer>
	</div>
</template>

<script>
	export default {
		props:{
			keyword: {
                type: String,
                default: null
            }
		},
		data(){
			return {
				currentPage: 1, //初始页
				pageSize : 10,
				tableData: [],
				total_records : 0,
				goods_ids : [],
				status : '',
				goods_id : '',
				ids:''
			}
		},
		methods: {
			sortBumber(row){
				if(row.sort == ''){
					this.$message.warning('排序号不能为空')
					return
				}
				if(row.sort < 0){
					this.$message.warning('排序号不能小于0')
					return
				}
				let params = {
					act : 'enterprise_goods_cat_sort_set',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					json_data:JSON.stringify([{id:row.id,sort:row.sort}])
				}
				this.$api.enterprise_goods_sort_set(params).then((res)=>{
					if(res.code == 0){
						this.getOnsalegoods()
						this.$message({
							showClose: false,
							message: '操作成功',
							type: 'success',
							offset: 350
						})
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350
						})
					}
					
				})
			},
			getOnsalegoods(){
				let param = {
					act : 'enterprise_goods_cat_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					status : 1,
					keyword : this.keyword,
					page : this.currentPage,
					size : this.pageSize
				}
				this.$api.login(param).then((res)=>{
					this.tableData = []
					if(res.code == 0){
						res.data.forEach((item) => {
							this.tableData.push({...item,is_confirm:item.status==1?true:false})
						})
						this.total_records = parseInt(res.total_records)
					}
				})
			},
			onoffGoods(status){
				let param = {
					act : status,
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					ids : this.goods_ids.join(',')
				}
				this.$api.login(param).then((res)=>{
					if(res.code == 0){
						this.$message({
							showClose: true,
							message: '操作成功',
							type: 'success',
							offset: 350,
							duration: 2000
						})
						this.getOnsalegoods()
					}else{
						this.$message({
							showClose: true,
							message: '操作失败',
							type: 'error',
							offset: 350,
							duration: 2000
						})
					}
				})
			},
			delGoods(){
				let param = {
					act : 'enterprise_goods_cat_del',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					ids : this.goods_ids.join(',')
				}
				this.$api.login(param).then((res)=>{
					if(res.code == 0){
						this.$message({
							showClose: true,
							message: '操作成功',
							type: 'success',
							offset: 350,
							duration: 2000
						})
						this.getOnsalegoods()
					}else{
						this.$message({
							showClose: true,
							message: '操作失败',
							type: 'error',
							offset: 350,
							duration: 2000
						})
					}
				})
			},
			switchChange(item){
				if(item.is_confirm == false){
					let status = 'enterprise_goods_off'
					this.goods_ids.push(item.id)
					this.onoffGoods(status)
				}else{
					let status = 'enterprise_goods_show'
					this.goods_ids.push(item.id)
					this.onoffGoods(status)
				}
			},
			batchOffshelves(){
				if(this.goods_ids.length == 0){
					this.$message({
						showClose: true,
						message: '请至少选择一个商品',
						type: 'error',
						offset: 350,
						duration: 2000
					})
				}else{
					let status = 'enterprise_goods_off'
					this.onoffGoods(status)
				}
			},
			batchDelshelves(){
				if(this.goods_ids.length == 0){
					this.$message({
						showClose: true,
						message: '请至少选择一个商品',
						type: 'error',
						offset: 350,
						duration: 2000
					})
				}else{
					this.$msgbox.confirm('是否确认此操作?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.delGoods()
					})
				}
			},
			handleSizeChange(size) {
				this.pageSize = size;
			},
			handleCurrentChange(currentPage) {
				this.currentPage = currentPage;
				this.getOnsalegoods()
			},
			handleSelectionChange(val) {
				let goodsId = []
				this.ids = []
				val.forEach((item) => {
					goodsId.push(item.id)
					this.ids.push(item.id)
				})
				this.goods_ids = goodsId
			},
			handleEdit(index, row) {
				row.editStatus = false
				row.editState = 0
				this.$router.push({path:'edit_item',query:row})
			},
			handleDelete(index, row){
				this.$msgbox.confirm('是否确认此操作?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.goods_ids.push(row.id)
					this.delGoods()
				})
			},
			openDetail(index, row){
				row.editStatus = true
				row.editState = 1
				this.$router.push({path:'publish_serve?id='+row.id})
			}
		},
		mounted() {
			this.getOnsalegoods()
			this.$nextTick(function() {
				this.$on('childmethods',function(){
					let param = {
						act : 'enterprise_goods_list',
						token: localStorage.getItem('token'),
						user_id: localStorage.getItem('user_id'),
						status : 1,
						keyword : this.keyword,
						page : this.currentPage,
						size : this.pageSize
					}
					this.$api.login(param).then((res)=>{
						this.tableData = []
						if(res.code == 0){
							res.data.forEach((item) => {
								this.tableData.push({...item,is_confirm:item.status==1?true:false})
							})
							this.total_records = parseInt(res.total_records)
						}
					})
				});
			});
		}
	}
</script>
<style>
	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
	  -webkit-appearance: none;
	}
	input[type="number"]{
	  -moz-appearance: textfield;
	}
</style>
<style lang="scss" scoped>
	.suojin{
		text-overflow: ellipsis;
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}
	.on_sale_table{
		.table {
			margin-top: 1.44rem;
			width: 100%;
			background: #FFFFFF;
			border-radius: 6px;
			overflow: hidden;
		}		
		footer {
			width: 100%;
			height: 3.85rem;
			background: #FFFFFF;
			margin-top: 1.44rem;
			border-radius: 6px;
			padding: 0 1.25rem;
			box-sizing: border-box;
		}
	}
</style>
